"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainNavigationCopy = exports.getMainNavigationConfigProperties = exports.selectTermByVisibleId = void 0;
var selectTermByVisibleId = function (_a, visibleId) {
    var _b, _c, _d;
    var clientGroupConfigs = _a.clientGroupConfigs;
    var terms = ((_c = (_b = clientGroupConfigs.data.terms) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.terms) ||
        clientGroupConfigs.data.defaultTerms;
    return ((_d = terms.find(function (term) { return term.id === visibleId; })) === null || _d === void 0 ? void 0 : _d.value) || "";
};
exports.selectTermByVisibleId = selectTermByVisibleId;
var getMainNavigationConfigProperties = function (_a) {
    var clientGroupConfigs = _a.clientGroupConfigs;
    return clientGroupConfigs.data.mainNavigation.properties;
};
exports.getMainNavigationConfigProperties = getMainNavigationConfigProperties;
var getMainNavigationCopy = function (store) {
    return store.clientGroupConfigs.data.mainNavigation.properties.copy;
};
exports.getMainNavigationCopy = getMainNavigationCopy;
//# sourceMappingURL=clientGroupConfigs.selectors.js.map